import React from 'react';
import ExchangeLittleFormPage from 'pages/Configuration/ConfigurationViews/ConfigurationWidget/WidgetsForms/Exchange/ExchangeLittle';
import * as Yup from 'yup';
import WidgetForm from '../WidgetForm';
import { useSelector } from 'react-redux';
import useFirebase from '../../../../hooks/Firebase/useFirebase';
import { toast } from 'react-toastify';

const ELForm = {
    base: {
        name: "base",
        placeholder: "Base (ex: EUR)",
        label: "Base",
        required: true
    },
    symbol: {
        name: "symbol",
        placeholder: "Symbol (ex: USD)",
        label: "Compare symbol",
        required: true
    },
    timer: {
        name: "timer",
        placeholder: "Timer (ms)",
        label: "Refresh timer",
        required: true
    }
}

const ELValidate = Yup.object().shape({
    [ELForm.base.name]: Yup.string().max(3, "Symbols are only 3 characters (e.g. USD, EUR, GBP...)").required("Required"),
    [ELForm.symbol.name]: Yup.string().max(3, "Symbols are only 3 characters (e.g. USD, EUR, GBP...)").required("Required"),
    [ELForm.timer.name]: Yup.number().required("Required"),
})

const ExchangeLittleForm = (props) => {
    const [, addElement] = useFirebase();
    const [ELInitial, setELInitial] = React.useState({
        [ELForm.base.name]: "",
        [ELForm.symbol.name]: "",
        [ELForm.timer.name]: "",
    })
    const {widgets} = useSelector(state => state.widgets);

    React.useEffect(() => {
        if (props.widget) {
            setELInitial(props.widget);
        }
    }, [props.widget])

    const handleSubmit = (values, formikBag) => {
        if (props.handleEdit) {
            props.handleEdit(values);
            const valuesParsed = widgets?.map(el => {
                if (el.id === props.widgetID) {
                    return {
                        ...el.widget,
                        ...values,
                    };
                }
                return el.widget;
            })
            addElement.setWidget("users", valuesParsed)
            toast("The widget was updated !");
            return
        }
        addElement.widget("users", {
            service_id: props.serviceSelected.id,
            widget_id: props.widgetSelected.id,
            timer: values[ELForm.timer.name],
            base: values[ELForm.base.name],
            symbol: values[ELForm.symbol.name]
        });
        toast("The widget was added to your dashboard !");
        formikBag.resetForm()
    }

    return (
        <WidgetForm WForm={ELForm} WInitial={ELInitial} WValidate={ELValidate} handleSubmit={handleSubmit}>
            <ExchangeLittleFormPage handleEdit={props.handleEdit} />
        </WidgetForm>
    );
};

export default ExchangeLittleForm;